import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import { TalentViewService, MasterService } from "../api/services.gen";
import {
    MasterOptionsMasterListData,
    TalentViewJobNotiQuestionCreateData,
    TalentViewJobNotiQuestionUpdateData,
} from "../api/types.gen";
import {INTERNAL_SERVER_ERROR} from "../constants/index";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

export const getOptionsMaster = createAsyncThunk(
    "getOptionsMaster",
    async (data: MasterOptionsMasterListData, thunkAPI: any) => {
        try {
            const res: any = await MasterService.masterOptionsMasterList(data);
            if (res.success) {
                return res.data;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const saveChangeJobStatus = createAsyncThunk(
    "saveChangeJobStatus",
    async (data: TalentViewJobNotiQuestionCreateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobNotiQuestionCreate(data);
            if (res.success) {
                return res.message;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const checkDisplayNotification = createAsyncThunk(
    "checkDisplayNotification",
    async (_, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobNotiQuestionRetrieve();
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

export const updateTalentCondition = createAsyncThunk(
    "updateTalentCondition",
    async (data: TalentViewJobNotiQuestionUpdateData, thunkAPI: any) => {
        try {
            const res: any = await TalentViewService.talentViewJobNotiQuestionUpdate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.TALENT, thunkAPI);
        }
    },
);

// Initial state of Redux
interface TalentNotificationState {
    loading: boolean;
    error: string | null;
    success: string | null;
    optionsMaster: [];
    displayPopup: boolean;
}

const initialState: TalentNotificationState = {
    loading: false,
    error: null,
    success: null,
    optionsMaster: [],
    displayPopup: false,
}

export const talentNotificationSlice = createSlice({
    name: "talentNotificationSlice",
    initialState,
    reducers: {
        setDisplayPopup: (state, action) => {
            state.displayPopup = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
        // reset state
        .addCase(resetAppState, () => initialState)

        // getOptionsMaster
        .addCase(getOptionsMaster.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getOptionsMaster.fulfilled, (state, action) => {
            state.loading = false;
            state.optionsMaster = action.payload;
        })
        .addCase(getOptionsMaster.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        //saveChangeJobStatus
        .addCase(saveChangeJobStatus.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(saveChangeJobStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload;
        })
        .addCase(saveChangeJobStatus.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        //checkDisplayNotification
        .addCase(checkDisplayNotification.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.displayPopup = false;
        })
        .addCase(checkDisplayNotification.fulfilled, (state, action) => {
            state.loading = false;
            state.displayPopup = true;
        })
        .addCase(checkDisplayNotification.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        //updateTalentCondition
        .addCase(updateTalentCondition.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(updateTalentCondition.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload;
        })
        .addCase(updateTalentCondition.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })
    }
});
const talentNotification = {
    ...talentNotificationSlice.actions
};
export {talentNotification}
export default talentNotificationSlice.reducer;